import { IValueLabelGeneric } from "@mctypes/global.types";
import { Box, Button, Flex, Group, Modal, TextInput } from "@mantine/core";
import React from "react";
import McDropdownNew from "../../../components/McDropdown/MCDropdownNew";
import { BatchJobTemplateEnum } from "./batchJobConstants";

const NewBatchJobModal: React.FC<{
  onCreate: (name: string, template: BatchJobTemplateEnum) => void;
  closeModal: () => void;
  templates: IValueLabelGeneric<string>[];
}> = ({ onCreate, closeModal, templates }) => {
  const [name, setName] = React.useState<string>("");
  const [template, setTemplate] = React.useState<BatchJobTemplateEnum>(null);

  return (
    <Modal opened onClose={closeModal} title="Ny BatchJob">
      <div>
        <Box w="100%">
          <Flex style={{ alignItems: "center", marginBottom: "0.5rem" }}>
            <Box w="20%">Navn</Box>
            <Box w="80%">
              <TextInput placeholder="Angi navn på batch-jobb" value={name} onChange={(e) => setName(e.target.value)} />
            </Box>
          </Flex>
          <Flex style={{ alignItems: "center", marginBottom: "0.5rem" }}>
            <Box w="20%">Mal</Box>
            <Box w="80%">
              <McDropdownNew
                color="mc-blue"
                buttonProps={{ style: { width: "100%" } }}
                options={templates}
                displayKey="label"
                currentValue={templates.find((temp) => temp.value === template)}
                onChange={(_, newTemplate) => setTemplate(newTemplate.value as BatchJobTemplateEnum)}
                defaultTitle="Velg batch-jobb-mal"
              />
            </Box>
          </Flex>
        </Box>
      </div>
      <Group justify="flex-end" mt="md">
        <Button disabled={name === "" || template == null} color="green" onClick={() => onCreate(name, template)}>
          Opprett
        </Button>
        <Button variant="default" onClick={closeModal}>
          Avbryt
        </Button>
      </Group>
    </Modal>
  );
};

export default NewBatchJobModal;
